module.exports = __webpack_public_path__ + "img/STADA-TR-Logo-white.c62b8f15.svg";